import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import LandingPage from './components/LandingPage'
import Home from './components/Home'
import M2 from './components/M2'
import M3 from './components/M3'
import M4 from './components/M4'
import M8 from './components/M8'
import Contact from './components/Contact'
import Terms from './components/Terms'
import ResetPassword from './pages/ResetPassword'
import VerifyEmail from './pages/VerifyEmail'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#0a0a0a] relative overflow-x-hidden">
        {/* Grid background pattern */}
        <div className="absolute inset-0 pointer-events-none bg-carbon-fiber" />

        {/* Header */}
        <Header />

        {/* Main content */}
        <main className="relative z-10">
          <Routes>
            <Route
              path="/"
              element={
                <LandingPage />
              }
            />
            <Route
              path="/browse"
              element={
                <Home />
              }
            />
            <Route path="/m2" element={<M2 />} />
            <Route path="/m3" element={<M3 />} />
            <Route path="/m4" element={<M4 />} />
            <Route path="/m8" element={<M8 />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />

      </div>
    </Router>
  )
}

export default App
